/**
 * EULA versioning constants — frontend mirror of
 * `Life4Earth.V2.Api/Constants/EulaConstants.cs`.
 *
 * Both sides MUST stay in sync. When updating the EULA:
 *   1. Edit `eula.en.md` with the new agreement text.
 *   2. Increment EULA_CURRENT_VERSION here.
 *   3. Increment EulaConstants.CURRENT_VERSION on the backend (must match).
 *   4. On next user login, the milestone evaluator detects the version
 *      gap and prompts the user to re-accept.
 *
 * Why a number, not a hash of the markdown: hashes change on cosmetic
 * edits (whitespace, typo fixes) which we don't want to trigger
 * re-acceptance. Versions are deliberate and human-decided.
 */
export const EULA_CURRENT_VERSION = 1;

/**
 * Human-readable label for the version. Optional — used in the modal
 * header so users know which version they're reviewing.
 */
export const EULA_CURRENT_VERSION_LABEL = 'Version 1 (Draft)';
